export const TabVerifyOptions = [
  {
    text: 'Film',
    value: 'Film',
    milestone: [
      {
        text: 'Camera Negative (PN)',
        value: 'Film|Camera Negative (PN)',
      },
      { text: 'Positive Print', value: 'Film|Positive Print' },
      { text: 'Sound Positive (SP)', value: 'Film|Sound Positive (SP)' },
      { text: 'Sound Negative (SN)', value: 'Film|Sound Negative (SN)' },
      { text: 'IN-Dupe Neg(IN)', value: 'Film|IN-Dupe Neg(IN)' },
      { text: 'IP-Dupe Pos(MP)', value: 'Film|IP-Dupe Pos(MP)' },
      {
        text: 'Reversal Neg(Intermediate)',
        value: 'Film|Reversal Neg(Intermediate)',
      },
      { text: 'Reversal Pos', value: 'Film|Reversal Pos' },
      { text: 'Overlay', value: 'Film|Overlay' },
      { text: 'Other', value: 'Film|Other' },
    ],
  },
  {
    text: 'Tape',
    value: 'Tape',
    milestone: [
      {
        text: 'MagneticTape open-reelvideotape-2-inch',
        value: 'Tape|2inch',
      },
      {
        text: 'MagneticTape open-reelvideotape-1-inch',
        value: 'Tape|1inch',
      },
      {
        text: 'MagneticTape open-reelvideotape ½-inch',
        value: 'Tape|½  inch',
      },
      {
        text: 'MagneticTape open-reelvideotape ¼ -inch',
        value: 'Tape|¼inch',
      },
      {
        text: 'MagneticTape casette  ¾ -inch or U-matic',
        value: 'Tape|¾inch',
      },
      { text: 'BetaCam', value: 'Tape|BetaCam' },
      { text: 'BetaCamSP', value: 'Tape|BetaCamSP' },
      { text: 'BetaCamSX', value: 'Tape|BetaCamSX' },
      { text: 'Digital BetaCam', value: 'Tape|Digital BetaCam' },
      { text: 'D1', value: 'Tape|D1' },
      { text: 'D2', value: 'Tape|D2' },
      { text: 'Video8', value: 'Tape|Video8' },
      { text: 'Hi-8', value: 'Tape|Hi8' },
      { text: 'Digital8', value: 'Tape|Digital8' },
      { text: 'DVCPro', value: 'Tape|DvCpro' },
      { text: 'DVCam', value: 'Tape|DvCam' },
      { text: 'HDCam', value: 'Tape|HdCam' },
    ],
  },
  {
    text: 'Document',
    value: 'Document',
    milestone: [
      {
        text: 'Camera Negative (PN)',
        value: 'Document|Camera Negative (PN)',
      },
      { text: 'Positive Print', value: 'Document|Positive Print' },
      {
        text: 'Sound Positive (SP)',
        value: 'Document|Sound Positive (SP)',
      },
      {
        text: 'Sound Negative (SN)',
        value: 'Document|Sound Negative (SN)',
      },
      { text: 'IN-Dupe Neg(IN)', value: 'Document|IN-Dupe Neg(IN)' },
      { text: 'IP-Dupe Pos(MP)', value: 'Document|IP-Dupe Pos(MP)' },
      {
        text: 'Reversal Neg(Intermediate)',
        value: 'Document|Reversal Neg(Intermediate)',
      },
      { text: 'Reversal Pos', value: 'Document|Reversal Pos' },
      { text: 'Overlay', value: 'Document|Overlay' },
      { text: 'Other', value: 'Document|Other' },
    ],
  },
  {
    text: 'Photograph',
    value: 'Photograph',
    milestone: [
      {
        text: 'Camera Negative (PN)',
        value: 'Photograph|Camera Negative (PN)',
      },
      { text: 'Positive Print', value: 'Photograph|Positive Print' },
      {
        text: 'Sound Positive (SP)',
        value: 'Photograph|Sound Positive (SP)',
      },
      {
        text: 'Sound Negative (SN)',
        value: 'Photograph|Sound Negative (SN)',
      },
      { text: 'IN-Dupe Neg(IN)', value: 'Photograph|IN-Dupe Neg(IN)' },
      { text: 'IP-Dupe Pos(MP)', value: 'Photograph|IP-Dupe Pos(MP)' },
      {
        text: 'Reversal Neg(Intermediate)',
        value: 'Photograph|Reversal Neg(Intermediate)',
      },
      { text: 'Reversal Pos', value: 'Photograph|Reversal Pos' },
      { text: 'Overlay', value: 'Photograph|Overlay' },
      { text: 'Other', value: 'Photograph|Other' },
    ],
  },
  {
    text: 'MicroFilms',
    value: 'MicroFilms',
    milestone: [
      {
        text: 'Camera Negative (PN)',
        value: 'MicroFilms|Camera Negative (PN)',
      },
      { text: 'Positive Print', value: 'MicroFilms|Positive Print' },
      {
        text: 'Sound Positive (SP)',
        value: 'MicroFilms|Sound Positive (SP)',
      },
      {
        text: 'Sound Negative (SN)',
        value: 'MicroFilms|Sound Negative (SN)',
      },
      { text: 'IN-Dupe Neg(IN)', value: 'MicroFilms|IN-Dupe Neg(IN)' },
      { text: 'IP-Dupe Pos(MP)', value: 'MicroFilms|IP-Dupe Pos(MP)' },
      {
        text: 'Reversal Neg(Intermediate)',
        value: 'MicroFilms|Reversal Neg(Intermediate)',
      },
      { text: 'Reversal Pos', value: 'MicroFilms|Reversal Pos' },
      { text: 'Overlay', value: 'MicroFilms|Overlay' },
      { text: 'Other', value: 'MicroFilms|Other' },
    ],
  },
  {
    text: 'Video Systems',
    value: 'Video Systems',
    milestone: [
      {
        text: 'NTSC (National Television System Committee)',
        value: 'Video Systems|NTSC',
      },
      { text: 'PAL (Phase Alternate Line)', value: 'Video Systems|PAL' },
      {
        text: 'SECAM (Séquentiel couleur à mémoire)',
        value: 'Video Systems|SECAM',
      },
    ],
  },
  {
    text: 'Optical Discs',
    value: 'Optical Discs',
    milestone: [
      { text: 'DVD', value: 'Optical Discs|DVD' },
      { text: 'Blue-Ray Discs', value: 'Optical Discs|Blue Ray' },
      { text: 'Laser Disc', value: 'Optical Discs|Laser Disc' },
    ],
  },
];
export const reelOptions = [
  { text: 'Reel1', value: 'Reel1' },
  { text: 'Reel2', value: 'Reel2' },
  { text: 'Reel3', value: 'Reel3' },
  { text: 'Reel4', value: 'Reel4' },
  { text: 'Reel5', value: 'Reel5' },
  { text: 'Reel6', value: 'Reel6' },
  { text: 'Reel7', value: 'Reel7' },
  { text: 'Reel8', value: 'Reel8' },
  { text: 'Reel9', value: 'Reel9' },
  { text: 'Reel10', value: 'Reel10' },
];
export const elemOptions = [
  { key: '1', text: '1', value: '1' },
  { key: '2', text: '2', value: '2' },
  { key: '3', text: '3', value: '3' },
  { key: '4', text: '4', value: '4' },
  { key: '5', text: '5', value: '5' },
  { key: '6', text: '6', value: '6' },
  { key: '7', text: '7', value: '7' },
  { key: '8', text: '8', value: '8' },
  { key: '9', text: '9', value: '9' },
  { key: '10', text: '10', value: '10' },
];
export const gaugeOptions = [
  { text: 'Super 8', value: 'Super 8' },
  { text: '16mm', value: '16mm' },
  { text: '35mm', value: '35mm' },
  { text: '65mm', value: 'G5mm' },
];
